import { Box, CircularProgress, CircularProgressProps, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const PaiCircularProgress = (props: CircularProgressProps & { value: number; dense?: boolean }) => {
  const { classes } = useStyles({ dense: props.dense });

  return (
    <Box className={classes.outerBox}>
      <CircularProgress className={classes.circle} variant="determinate" size={props.dense ? 80 : 150} thickness={5} {...props} />
      <Box className={classes.innerBox}>
        <Typography className={classes.score} variant="caption" component="div">{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles<{ dense?: boolean }>()((theme, { dense }) => ({
  outerBox: {
    position: 'relative',
    display: 'inline-flex',
  },
  innerBox: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  circle: {
    color: theme.palette.primary.main,
  },
  score: {
    fontSize: theme.typography.pxToRem(dense ? 16 : 22),
    fontWeight: 900,
  },
}));

export default PaiCircularProgress;
